import React from 'react'

const CreateTnx = () => {
  return (
    <div>
      
    </div>
  )
}

export default CreateTnx
